import React from 'react';
import PropTypes from 'prop-types';

const HazardousItemsPolicyPage = ({ signatureData }) => {

  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  return (
    <div
      style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "1200px",
        fontSize: "18px"
      }}
    >
      {/* Title */}
<div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{
          fontSize: '18pt',
          borderBottom: '2px solid black',
          display: 'inline-block'
        }}>
    SEARCH FOR HAZARDOUS ITEMS
        </h2>
      </div>
      

      {/* Policy Content */}
      <div style={{ marginBottom: '20px' }}>
        <p style={{ marginBottom: '15px' }}>
          Legacy Healing Center Margate residences has the right and the responsibility to search members' belongings and the residences for illegal substances and inappropriate / hazardous items.
        </p>

        <p style={{ marginBottom: '15px' }}>
          Legacy Healing Center Margate seeks to ensure the safety of all residents and to provide a safe environment conducive to recovery from addiction.
        </p>

        <p style={{ marginBottom: '15px' }}>
          Upon admission, a staff member will search the resident's personal belongings for illegal or inappropriate / hazardous items. This is to include the resident's person, belongings, and vehicles/property that will be kept on premises. The new resident will be informed of Legacy's policy with regards to keeping illegal substances or inappropriate / hazardous items in the residence.
        </p>

        <p style={{ marginBottom: '15px' }}>
          Periodic searches (timing is decided by the staff on a weekly basis) of residences and belongings will be done by staff in search of any items that may be deemed inappropriate / hazardous.
        </p>

        <p style={{ marginBottom: '15px' }}>
          If a resident is found to be in possession of an illegal or inappropriate / hazardous item upon admission the item or substance will be confiscated by the staff member conducting the search. If during the residence search, it is discovered that a resident is keeping an illegal substance (ex. Drugs and / or alcohol) or an inappropriate / hazardous item (ex. mood altering chemicals, weapons or pornography) the item(s) will be confiscated, and the resident will be discharged.
        </p>

        <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
          Inappropriate / Hazardous items include but are not limited to:
        </p>
        <ul style={{
          listStyleType: 'disc',
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li>Illegal drugs – cocaine, heroin, amphetamines, marijuana etc</li>
          <li>Legal drugs – that are mood altering – alcohol and anything containing alcohol, prescription drugs etc.</li>
          <li>Weapons or anything heavy or sharp enough to be used as a weapon.</li>
          <li>Pornography</li>
        </ul>

        <p style={{ marginBottom: '15px', fontWeight: 'bold', }}>
          I agree and authorize staff of Legacy Healing to conduct periodic hazardous items searches of my personal property. I understand that failure to do so may result in dismissal from the housing unit.
        </p>
      </div>

      {/* Signature Section */}
      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>
    </div>
  );
};

HazardousItemsPolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default HazardousItemsPolicyPage;